module.exports = __webpack_public_path__ + "img/1547080776.a21579df.jpg";